import wvusClientLogger from 'wvus-client-logger';
import appSettings from "../settings/appSettings";
import { getChildIdParam } from "../helpers/helpers";

export function getClientLoggerInstance() { 
    // Return instance if it exist
    if (window.wvusClientLogger) {
      return window.wvusClientLogger;
    }   
    // Create new instance
    const sendConsoleErrors = true;
    const { mywv="https://my.worldvision.org" } = appSettings?.urls;
  
    window.wvusClientLogger =  new wvusClientLogger({
      logglyKey: appSettings.loggly_customer_key, 
      webProperty: "My Sponsored Child Embeded App", 
      source: "My Sponsored Child",
      env: mywv,
      sendConsoleErrors: sendConsoleErrors,
    });
    return window.wvusClientLogger;
}

//cookie parsing function for SESSpartauth cookie
function get_cookie(cookie_name) {
        let c_name = cookie_name + "=";
        let cookie_decoded = decodeURIComponent(document.cookie);
        let cookie_parts = cookie_decoded.split(';');
        
        for(let i = 0; i <cookie_parts.length; i++) {
            let c = cookie_parts[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(c_name) == 0) {
                return c.substring(c_name.length, c.length);
            }
        }
        return "";
}

    


export function logToClientLogger(message, logLevel = 200) {
   // we need to use the SESSpartauth cookie to get the Supporter Number, empty if no cookie 
    try {
    var supporterNumber = '';
    const cookie = get_cookie('SESSpartauth');
    if(cookie){
        const parsedCookie = JSON.parse(cookie);
        supporterNumber = parsedCookie.supporter_number || '';
    }
    const wvusClientLogger = getClientLoggerInstance();
    const childId = getChildIdParam(); 
    //log message values to loggly as object
    const logMessage = JSON.stringify({
        message: message,
        supporterNumber: supporterNumber || "",
        childId: childId || "",
    });
    const level = logLevel;
    return wvusClientLogger.log(logMessage, level);
    }
    catch {
      //if something goes wrong with the client logger, capture relevant info in the console:
      console.log("client logger failed; logging to console", message, logLevel);  
    }   
}